var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button-outlined",class:{
  'button-outlined-small': _vm.isSmall,
  'button-outlined-normal': !_vm.isSmall,
},attrs:{"href":_vm.uri},on:{"click":_vm.listeners}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }